var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wjl-edit" },
    [
      _c(
        "div",
        {
          ref: "wjlEditRight",
          staticClass: "wjlEditRight",
          style: _vm.leftDivStyle
        },
        [
          _c("div", { staticClass: "question_title" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.questionData.sectionName === undefined
                    ? ""
                    : _vm.questionData.sectionName
                )
              )
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "(" +
                  _vm._s(
                    _vm.questionData.sectionPrompt +
                      "  本题" +
                      _vm.questionData.score +
                      "分。"
                  ) +
                  ")"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "paperQusetionContent" }, [
            _vm.questionData.questionContent
              ? _c("div", {
                  staticClass: "editorShowArea ql-editor title_one",
                  domProps: {
                    innerHTML: _vm._s(_vm.questionData.questionContent)
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "editorShowArea ql-editor",
              staticStyle: { overflow: "auto" },
              domProps: {
                innerHTML: _vm._s(_vm.questionData.questionDto.questionContent)
              }
            })
          ]),
          _vm._v(" "),
          _vm.isShowLeft
            ? _c(
                "div",
                { staticClass: "startBtn" },
                [
                  _vm.isIt
                    ? [
                        _vm.openRight
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "bury",
                                    rawName: "v-bury",
                                    value: { start: true },
                                    expression: "{ start: true }"
                                  }
                                ],
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.saveResults()
                                  }
                                }
                              },
                              [_vm._v("保存答案")]
                            )
                          : _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "bury",
                                    rawName: "v-bury",
                                    value: { start: true },
                                    expression: "{ start: true }"
                                  }
                                ],
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.go_coder()
                                  }
                                }
                              },
                              [_vm._v("开始答题")]
                            )
                      ]
                    : _c("examinationBtn", {
                        attrs: {
                          type: Number(_vm.productFlag),
                          btnFlag: "examination",
                          queryData: _vm.queryData,
                          questionData: _vm.questionData
                        },
                        on: { jumpStudy: _vm.jumpStudy }
                      })
                ],
                2
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.openRight
        ? _c(
            "div",
            {
              staticClass: "code_line",
              on: {
                mousedown: function($event) {
                  $event.stopPropagation()
                  return _vm.lineMove($event)
                }
              }
            },
            [
              _c("span", { staticClass: "code_line_icon" }, [
                _c(
                  "svg",
                  {
                    staticClass: "icon svg-icon",
                    staticStyle: { width: "20px", height: "13px" },
                    attrs: { "aria-hidden": "true" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-tuozhuai1" } })]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "code_operation", style: _vm.rightDivStyle },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isDrag,
                expression: "isDrag"
              }
            ],
            staticClass: "programming_right_mask"
          }),
          _vm._v(" "),
          _vm.openRight
            ? _c("span", {
                staticClass: "el-icon-arrow-right close_code_operation",
                attrs: { title: "收起" },
                on: { click: _vm.changeOpenRight }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("it-env", {
            ref: "itEnv",
            attrs: {
              "show-tools-box": true,
              "platform-type": _vm.showRightType,
              "question-answer": _vm.questionAnswer,
              "iframe-src": _vm.iframeAddress,
              "question-id": _vm.questionData.questionId,
              "code-refresh": _vm.codeRefresh
            },
            on: { itEnvScore: _vm.resultScore },
            model: {
              value: _vm.taskData,
              callback: function($$v) {
                _vm.taskData = $$v
              },
              expression: "taskData"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "questionEnclosure" }, [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.enclosureUlShow,
                expression: "enclosureUlShow"
              }
            ],
            staticClass: "enclosureUl"
          },
          _vm._l(_vm.questionEnclosure, function(item, index) {
            return _c(
              "li",
              { key: index, staticClass: "questionEnclosureItem" },
              [
                _c(
                  "span",
                  {
                    staticClass: "enclosurePopoverLabel",
                    attrs: { title: item.name },
                    on: {
                      click: function($event) {
                        return _vm.handlePreview(item.newAttaUrl)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                ),
                _vm._v(" "),
                _c("span", {
                  staticClass: "el-icon-download enclosureDown",
                  on: {
                    click: function($event) {
                      return _vm.handleImport(item.id)
                    }
                  }
                })
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.questionEnclosure.length && !_vm.enclosureUlShow,
                expression: "questionEnclosure.length && !enclosureUlShow"
              }
            ],
            staticClass: "questionEnclosureStyle",
            on: { dblclick: _vm.dblclick, click: _vm.openQuestionEnclosure }
          },
          [
            _c("span", { staticClass: "el-icon-paperclip" }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: { "padding-right": "10px", "padding-left": "3px" }
              },
              [_vm._v("附件")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "number" }, [
              _vm._v(_vm._s(_vm.questionEnclosure.length))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.questionEnclosure.length && _vm.enclosureUlShow,
                expression: "questionEnclosure.length && enclosureUlShow"
              }
            ],
            staticClass: "questionEnclosureStyle"
          },
          [
            _c("span"),
            _vm._v(" "),
            _c("span", {
              staticClass: "el-icon-close",
              staticStyle: { color: "#d2d2d7" },
              on: {
                click: function($event) {
                  _vm.enclosureUlShow = false
                }
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.filePreviewDialog,
            "destroy-on-close": "",
            "append-to-body": "",
            width: "80%",
            top: "7%"
          },
          on: {
            "update:visible": function($event) {
              _vm.filePreviewDialog = $event
            }
          }
        },
        [
          _c("iframe", {
            staticStyle: { width: "100%" },
            style: { height: (_vm.windowHeight / 6) * 4 + "px" },
            attrs: { src: _vm.filePreviewUrl, frameborder: "0" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-495c2d0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495c2d0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testComponent/operation.vue
// module id = null
// module chunks = 